import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchExamInstructionRequest,
  getPyqTopicWiseSetsRequest,
  setPaperId,
  setSelectedSetId,
  setTestDetails,
  setTestType,
  submitExamRequest,
} from "../../../../../redux/exam/examSlice";
import "./PyqTopicWiseSet.css";
import { useHistory } from "react-router-dom";
import images from "../../../../../utilities/images/images";
import GameficationMode from "../../../../tests/Dashboard/GameficationMode";
import ResumeModal from "../../../../../shared/components/Modal/ResumeModal/ResumeModal";

const PyqTopicWiseSet = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    pyqTopicWiseSets,
    activeSubject,
    selectedTopic,
    plannerDetails,
    selectedType,
    testDetails,
    loadingTopicWiseSets,
    error,
  } =
    useSelector((state) => state.examSlice);

  const [gmOpen, setGmOpen] = useState(false);
  const [selectedSet, setSelectedSet] = useState(null);
  const [showResumeModal, setShowResumeModal] = useState(false);
  const getResumeStorageKey = (set) => `exam_mode_${set?.set_id}`;
  const getGamificationStorageKey = (set) =>
    `exam_gamification_${set?.set_id}`;
  const getResumeModeConfig = (set) => {
    const activeTestId =
      testDetails?.testId || testDetails?.setId || testDetails?.paperId;
    const isSameActiveTest = String(activeTestId) === String(set?.set_id);

    const storedMode = localStorage.getItem(getResumeStorageKey(set));
    const backendMode =
      storedMode ||
      set?.practiceMode ||
      set?.practice_mode ||
      set?.mode ||
      set?.selected_mode ||
      set?.last_mode ||
      (isSameActiveTest ? testDetails?.practiceMode : undefined);
    const normalizedMode =
      String(backendMode || "").toLowerCase() === "practice"
        ? "practice"
        : "test";
    const storedGamification = localStorage.getItem(
      getGamificationStorageKey(set)
    );
    const gamificationOn =
      storedGamification === "1" ||
      set?.gamificationOn === true ||
      set?.gamification_on === 1 ||
      set?.gamification_status === 1 ||
      set?.is_gamification === 1 ||
      (isSameActiveTest && testDetails?.gamificationOn === true);

    return {
      selectedMode: normalizedMode,
      gamificationOn: normalizedMode === "practice" ? gamificationOn : false,
    };
  };

  const {
    planner_id,
    planner_type_id,
    id: paperType,
    category_id,
  } = plannerDetails || {};

  /* ===================== FETCH SETS ===================== */
  useEffect(() => {
    if (activeSubject && selectedTopic?.topic_name) {
      dispatch(
        getPyqTopicWiseSetsRequest({
          subject: activeSubject,
          topic: selectedTopic.topic_name,
          format: selectedType, 
        })
      );
    }
  }, [dispatch, activeSubject, selectedTopic]);

  /* ===================== OPEN GAMIFICATION MODAL ===================== */
  const handleFooterClick = (set) => {
    setSelectedSet(set);
    setGmOpen(true);
  };
  const handleResumeClick = (set) => {
    setSelectedSet(set);
    setShowResumeModal(true);
  };

  /* ===================== CONFIRM GAMIFICATION ===================== */
  const handleGamificationConfirm = ({ selectedMode, gamificationOn }) => {
    if (!selectedSet) return;

    // const paperId =
    //   selectedSet.paper_id || selectedSet.test_id || selectedSet.set_id;

    // const testId = selectedSet.test_id || selectedSet.set_id;
    const paperId = undefined;
const testId = undefined;

    dispatch(setSelectedSetId(selectedSet.set_id));
    dispatch(setTestType({ id: paperType }));

    const payload = {
      paperId,
      testId,
      paperType,
      plannerId: planner_id,
      categoryId: category_id || "",
      setId: selectedSet.set_id,
      practiceMode: selectedMode,
      gamificationOn,    
      source: "topicwise",          
    };
    localStorage.setItem(getResumeStorageKey(selectedSet), selectedMode || "test");
    localStorage.setItem(
      getGamificationStorageKey(selectedSet),
      gamificationOn ? "1" : "0"
    );

    dispatch(setTestDetails(payload));
    dispatch(fetchExamInstructionRequest(payload));

    setGmOpen(false);
    history.push("/TestInstruction");
  };
  const handleResumeContinue = () => {
    if (!selectedSet) return;
    const resumeConfig = getResumeModeConfig(selectedSet);

    dispatch(setSelectedSetId(selectedSet.set_id));
    dispatch(setTestType({ id: paperType }));

    const payload = {
      paperId: undefined,
      testId: undefined,
      paperType,
      plannerId: planner_id,
      categoryId: category_id || "",
      setId: selectedSet.set_id,
      practiceMode: resumeConfig.selectedMode,
      gamificationOn: resumeConfig.gamificationOn,
      source: "topicwise",
    };
    dispatch(setTestDetails(payload));
    setShowResumeModal(false);
    history.push("/test", {
      paperType: payload.paperType,
      setId: payload.setId,
    });
  };

  const handleResumeSubmit = () => {
    if (!selectedSet) return;
    const resumeConfig = getResumeModeConfig(selectedSet);

    dispatch(setSelectedSetId(selectedSet.set_id));
    dispatch(setTestType({ id: paperType }));

    const payload = {
      paperId: undefined,
      testId: undefined,
      paperType,
      plannerId: planner_id,
      categoryId: category_id || "",
      setId: selectedSet.set_id,
      practiceMode: resumeConfig.selectedMode,
      gamificationOn: resumeConfig.gamificationOn,
      source: "topicwise",
    };
    dispatch(setTestDetails(payload));
    dispatch(
      submitExamRequest({
        paperType: payload.paperType,
        paperId: payload.paperId,
        plannerId: payload.plannerId,
        setId: payload.setId,
        time: 0,
      })
    );
    setShowResumeModal(false);
    history.push(
      payload.practiceMode === "practice" ? "/practice-summary" : "/analytics"
    );
  };

  /* ===================== UI STATES ===================== */
  if (loadingTopicWiseSets) {
    return <div className="loading">Loading sets...</div>;
  }

  if (error) {
    return <div className="loading">Unable to load sets. Please try again.</div>;
  }

  if (!pyqTopicWiseSets?.sets || pyqTopicWiseSets.sets.length === 0) {
    return <div className="loading">No sets available for this topic.</div>;
  }

  const getButton = (set) => {
    // const isLocked = set.is_subscribed === 0;
    // const isStarted = set.attempted_questions > 0;
    // const isCompleted =
    //   set.progress_percentage === 100 ||
    //   set.attempted_questions === set.total_questions;

    if (set.is_subscribed === 0) {
      return (
        <button
          className="practice-btn locked-btn"
          disabled
          onClick={() => history.push(`/store/${set.package_id}`)}
        >
          Locked
        </button>
      );
    }

    if (set.show_reattempt === 1) {
      return (
        <button
          className="practice-btn reattempt-btn"
          onClick={() => handleFooterClick(set)}
        >
          Reattempt ({set.user_attempt_count})
        </button>
      );
    }

    if (set.show_resume === 1) {
      return (
        <button
          className="practice-btn resume-btn"
          onClick={() => handleResumeClick(set)}
        >
          Resume
        </button>
      );
    }

    return (
      <button
        className="practice-btn start-btn"
        onClick={() => handleFooterClick(set)}
      >
        Start Test
      </button>
    );
  };

  /* ===================== RENDER ===================== */
  const handleAnalyticsClick = (set) => {
    const payload = {
      paperId: undefined,
      testId: undefined,
      paperType,
      plannerId: planner_id,
      plannerTypeId: planner_type_id,
      categoryId: category_id || "",
      setId: set.set_id,
      planner_test_id: undefined,
      source: "topicwise",
    };

    dispatch(setSelectedSetId(set.set_id));
    dispatch(setTestType({ id: paperType }));
    dispatch(setPaperId(null));
    dispatch(setTestDetails(payload));

    history.push("/analytics", {
      paper_type: paperType,
      set_id: set.set_id,
    });
  };
  return (
    <>
      <div className="topic-wise-header">
        <img
          src={images.new_backarrow}
          alt="Back"
          // style={{ width: "24px", height: "24px", cursor: "pointer" }}
          onClick={() => history.push("/practice/topic-wise")}
        />
        <h3 className="header-title">Topic Wise Set</h3>
      </div>

      <div className="container">
        <div className="wrapper">
          <div className="grid">
            {pyqTopicWiseSets.sets.map((set) => {
               const isCompleted = set.analytics_visible === 1;
      return(
              <div key={set.set_id} className="card-pyq">
                <div className="card-header">
                  <div className="circle">  <img src={set.icon} alt="set icon" className="card-icon" /></div>

                  <div className="card-info">
                    <h3 className="set-name">{set.set_name}</h3>
                    <p className="set-details">
                      {set.total_questions} Questions
                      <br />({set.year_range})
                    </p>
                  </div>
                   <div className="card-top-icon" 
                    style={{
    cursor: isCompleted ? "pointer" : "not-allowed",
    opacity: isCompleted ? 1 : 0.5,
  }}
  onClick={() => {
    if (isCompleted) handleAnalyticsClick(set);
  }}>
                    
                <img src={images.topicanalytics_icon} alt="stats icon" />
                </div>
                </div>
                <div className="card-footer">{getButton(set)}</div>
              </div>
      );
            })}
          </div>
        </div>
      </div>

      {/* ===================== GAMIFICATION MODAL ===================== */}
      <GameficationMode
        isOpen={gmOpen}
         attemptUsed={selectedSet?.user_attempt_count || 0}
         attemptMessage={selectedSet?.attempt_message} 
        onClose={() => setGmOpen(false)}
        onConfirm={handleGamificationConfirm}
      />
      <ResumeModal
        isOpen={showResumeModal}
        onClose={() => setShowResumeModal(false)}
        onSubmit={handleResumeSubmit}
        onResume={handleResumeContinue}
      />
    </>
  );
};

export default PyqTopicWiseSet;
